export default {
      id: "logo-frcito-usage",
      viewBox: "0 0 84.44 35.62",
      url: __webpack_public_path__ + "../images/sprites.svg#logo-frcito",
      toString: function () {
        return this.url;
      }
    }